import { FormControl } from '@angular/forms';

import { Ldap } from './ldap';

export class Attribute {
  public isVisibleControl = new FormControl<boolean>(false);

  constructor(
    public readonly displayName: string,
    public readonly displayNameKey: string,
    public readonly keyWithBrackets: string,
    public readonly key: string,
    public readonly value: string,
    public readonly type: string,
    public readonly source: Ldap | null,
    public readonly editable: boolean
  ) {}
}
